import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { Chat } from '../Chat'

@InputType()
export class MarkChatReadArgs extends ActionArgs {
  @Field(() => ID)
  chatId: string
}

export interface IMarkChatRead extends IAction<Chat, MarkChatReadArgs> {}
